// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';
import CustomPieChartLabel from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabel';
import CustomPieChartLabelLine from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabelLine';

const pieLabelText = (props) => <CustomPieChartLabel {...props} width={200} fontSize={14} />;

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Average', payloadKey: 'average' },
];

const DonutChart = ({ data, chartRef, aspect }) => {
  const { t } = useTranslation();
  if (!data?.length) return <p>{t('engagement.no_responses')}</p>;

  const legendPayload = data.map((item) => ({
    id: item.label,
    type: 'square',
    value: item.label,
    color: item.color,
    percentage: item.percentage,
  }));

  return (
    <div className="donut-chart">
      <ResponsiveContainer width="100%" aspect={aspect}>
        <PieChart ref={chartRef}>
          <Tooltip content={<CustomTooltip attributes={tooltipAttributes} />} />
          <Pie
            data={data}
            dataKey="average"
            outerRadius="80%"
            innerRadius="40%"
            labelLine={CustomPieChartLabelLine}
            label={pieLabelText}
          >
            {data.map((entry) => (
              <Cell key={entry.label} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <Legend
        align="left"
        payload={legendPayload}
        layout="vertical"
        width="100%"
        wrapperStyle={{ position: 'static' }}
      />
    </div>
  );
};

DonutChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      color: PropTypes.string,
      average: PropTypes.number,
      percentage: PropTypes.number,
    })
  ).isRequired,
  chartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  aspect: PropTypes.number,
};

DonutChart.defaultProps = {
  chartRef: null,
  aspect: 2,
};

Legend.propTypes = {
  width: PropTypes.string.isRequired,
};

export default DonutChart;
